import { z } from "zod";

export const StockBudgetItemSchema = z.object({
  stockBudgetItemId: z.string(),
  costType: z.string(),
  custCostType: z.string(),
  description: z.string(),
  columns: z.number().nullable(),
  columnOrder: z.array(z.number()),
  exportable: z.boolean(),
});

export const StockBudgetItemListSchema = z.array(StockBudgetItemSchema);

export type StockBudgetItem = z.infer<typeof StockBudgetItemSchema>;
